module.exports = __webpack_public_path__ + "img/popup1.dbe140aa.png";